function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Timeline");

var SvgTimeline = function SvgTimeline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("path", {
    d: "M8.29,22.85a6.64,6.64,0,0,0,6.62,6.62H25.18V16.24H14.91A6.63,6.63,0,0,0,8.29,22.85Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M87.35,22.85a6.62,6.62,0,0,0-6.61-6.61H28.88V29.47H80.74A6.63,6.63,0,0,0,87.35,22.85Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M8.29,39.62a6.64,6.64,0,0,0,6.62,6.62H25.18V33H14.91A6.64,6.64,0,0,0,8.29,39.62Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M80.74,33H28.88V46.24H80.74a6.62,6.62,0,0,0,0-13.24Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M80.74,49.76H28.88V63H80.74a6.62,6.62,0,0,0,0-13.24Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M8.29,56.38A6.64,6.64,0,0,0,14.91,63H25.18V49.76H14.91A6.64,6.64,0,0,0,8.29,56.38Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M80.74,66.53H28.88V79.76H80.74a6.62,6.62,0,0,0,0-13.23Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M8.29,73.15a6.63,6.63,0,0,0,6.62,6.61H25.18V66.53H14.91A6.64,6.64,0,0,0,8.29,73.15Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("polygon", {
    points: "26.63 16.23 26.63 29.47 26.63 33 26.63 46.23 26.63 49.77 26.63 63 26.63 66.53 26.63 79.77 26.63 87 27.43 87 27.43 79.77 27.43 66.53 27.43 63 27.43 49.77 27.43 46.23 27.43 33 27.43 29.47 27.43 16.23 27.43 11.12 26.63 11.12 26.63 16.23",
    style: {
      fill: "#ccc"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTimeline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TIMELINE.607b1f60.svg";
export { ForwardRef as ReactComponent };